import { useSelector } from 'react-redux';
import useFilterLogic from '../../hooks/useFilterLogic';
import { loadLinksFilters } from '../../store/action_creators/links.actions';
import { LinkTypeEnum } from '../../store/config/enums';
import { RootState } from '../../store/config/types';
import LinksFilterLayout from './LinksFiltersLayout';

interface LinksFiltersProps {
  businessId: number;
  linkType: LinkTypeEnum;
}

function LinksFilters({ businessId, linkType }: LinksFiltersProps) {
  const { links } = useSelector((state: RootState) => state);

  const {
    openFilters,
    setOpenFilters,
    searchTerm,
    setSearchTerm,
    loadFilters,
    searchLinks,
    closeFiltersDialog,
  } = useFilterLogic({
    businessId,
    linkType,
    loadFiltersAction: loadLinksFilters,
    filtersState: links.linksFilters,
  });

  return (
    <LinksFilterLayout
      openFilters={openFilters}
      setOpenFilters={setOpenFilters}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      searchLinks={searchLinks}
      closeFiltersDialog={closeFiltersDialog}
      loadFilters={loadFilters}
      filtersState={links.linksFilters}
    />
  );
}

export default LinksFilters;
